export enum LocalStorageNamespace {
  UserEmail = 'user.email',
  Locale = 'user.locale'
}
